import React from 'react'

import { MonitoringListStatusTagRender } from '@app/components/renderers'
import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { CustomEllipsis } from '@app/constants/customEllipsis'
import { ColumnWidth } from '@app/constants/columnWidth'

import { columnTitleSchema } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { RegistryCurrentListsDataSource } from '../types'

const getOptions = (): Array<Column<RegistryCurrentListsDataSource>> => {
  const columnsKeys = Object.keys(columnTitleSchema).filter(key => !['status'].includes(key)) as Array<
  keyof RegistryCurrentListsDataSource
  >

  return columnsKeys.map(key => {
    return {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key]),
      ...ColumnWidth
    }
  })
}

export const getColumns = (): Array<Column<RegistryCurrentListsDataSource>> => {
  return getColumnsFromMap<RegistryCurrentListsDataSource>({
    columnTitleMap: columnTitleSchema,
    options: [
      ...getOptions(),
      {
        key: 'status',
        sorter: (a, b) => sorterDispatcher(a.status, b.status),
        render: (_, { status }) => <MonitoringListStatusTagRender status={ status } />
      }
    ]
  })
}
